import dynamic from 'next/dynamic';
import Head from 'next/head';
import React from 'react';
import { END } from 'redux-saga';

import LoadingElement from 'components/common/Loading';
import { searchCategoryActionRequest } from 'redux/common/categories/action';
import { wrapper } from 'redux/store';
import { widgetsActionRequest } from 'redux/stores/action';

export const getServerSideProps = wrapper.getServerSideProps((store) => async () => {
	store.dispatch(widgetsActionRequest({}));
	store.dispatch(searchCategoryActionRequest({}));
	store.dispatch(END);
	await store.sagaTask.toPromise();

	return {
		props: {
			title: 'کیپا | لیست فروشندگان',
		},
	};
});
// TODO: Add description

const StoreKeepa = dynamic(() => import('screen/Stores'), {
	ssr: true,
	loading: () => <LoadingElement />,
});

const Store = (props) => (
	<>
		<Head>
			<title>{props.title}</title>
		</Head>
		<StoreKeepa />
	</>
);

export default Store;
